export default __webpack_public_path__ + "static/media/success-check.fbd7a6d7.svg";